import { useEffect, useState } from "react";
import { isAfter, isBefore, parseISO, subDays, addDays } from "date-fns";
import { useActasStore } from "../../store/actasStore";
import InputRangoFecha from "../inputRangoFecha";
import { Form } from "react-bootstrap";

const FilterBar = ({ filtros, setFiltros, setFiltersField, estado_id }) => {
  // console.log(filtros)
  const { actas, actasFilter, localidades, tipos, setActasFilter, cp } = useActasStore();

  useEffect(() => {
    const actasFiltrados = actas?.filter((acta) => {
      let isInRage = true;
      const fecha = parseISO(acta.fecha_hora.split(" ")[0].split("/").reverse().join("-"));
      const fechaDesde = parseISO(filtros.fecha_desde);
      const fechaHasta = parseISO(filtros.fecha_hasta);
      const ajustarFechaDesde = subDays(fechaDesde, 1);
      const ajustarFechaHasta = addDays(fechaHasta, 1);
      if (filtros.fecha_desde != "" && filtros.fecha_hasta != "") {
        isInRage = isAfter(fecha, ajustarFechaDesde) && isBefore(fecha, ajustarFechaHasta);
      }

      if (filtros.fecha_desde != "" && filtros.fecha_hasta == "") {
        isInRage = isAfter(fecha, ajustarFechaDesde);
      }

      if (filtros.fecha_desde == "" && filtros.fecha_hasta != "") {
        isInRage = isBefore(fecha, ajustarFechaHasta);
      }

      if (
        // acta.localidad?.includes(filtros.localidad) &&
        // acta.codigo_postal?.includes(filtros.codigo_postal) &&
        acta.tipo?.includes(filtros.tipo) &&
        isInRage ||
        // acta?.notificadores[0]?.persona?.nombre?.toLowerCase().includes(filtros.search.toLowerCase()) ||
        acta.plate?.toLowerCase().includes(filtros.search.toLowerCase()) ||
        acta.numero_acta?.toString().toLowerCase().includes((filtros.search.toLowerCase())) ||
        acta.documento_titular?.toLowerCase().includes(filtros.search.toLowerCase())

      ) {
        return acta;
      }
    });
    // console.log(actasFiltrados)
    setActasFilter(actasFiltrados);
  }, [filtros]);

  // console.log(actas)
  // console.log(filtros)


  return (
    <>
      <div className="d-flex justify-content-end   gap-2">
        {/* <InputRangoFecha setFiltros={setFiltros} /> */}
        {
          estado_id == 3 &&
          <Form.Group>
            <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
              Domicilio electronico
            </Form.Label>
            <Form.Check
              name="domicilio_notificacion_id"
              onChange={(e) => {
                
                  setFiltersField((prevState) => ({
                    ...prevState,
                    [e.target.name]: e.target.checked,
                  }));
                }
              }
            ></Form.Check>
          </Form.Group>
        }
        <Form.Group>
          <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
            Zonas
          </Form.Label>
          <Form.Select
            // onChange={(e) => {
            //   setFiltros((prevState) => ({
            //     ...prevState,
            //     zonales: e.target.value,
            //   }));
            // }}
            name="codigo_postal"
            onChange={(e) => {
              // console.log(e.target.name)
              setFiltersField((prevState) => ({
                ...prevState,
                [e.target.name]: e.target.value,
              }));
            }}
          >
            <option value="">Seleccione zona</option>
            <option value="zonales">Locales</option>
            <option value="foraneas">Extraña jurisdicción</option>
            {/* {cp?.map((cp, index) => (
              <option key={index} value={cp}>
                {cp}
              </option>
            ))} */}
          </Form.Select>
        </Form.Group>
        {/* 
        <Form.Group>
          <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
            Código Postal
          </Form.Label>
          <Form.Select
            onChange={(e) => {
              setFiltros((prevState) => ({
                ...prevState,
                codigo_postal: e.target.value,
              }));
            }}
          >
            <option value="">Seleccione CP</option>
            {cp?.map((cp, index) => (
              <option key={index} value={cp}>
                {cp}
              </option>
            ))}
          </Form.Select>
        </Form.Group> */}

        <Form.Group>
          <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem" }}>
            Buscar
          </Form.Label>
          <Form.Control
            onChange={(e) => {
              setFiltros((prevState) => ({
                ...prevState,
                search: e.target.value,
              }));
            }}
          ></Form.Control>
        </Form.Group>
      </div>
    </>
  );
};
export default FilterBar;
